import {
    ContentResponse,
    CreateContentBodyParams,
    CreateMediaUploadBodyParams,
    CreateWebsiteScreenshotQueryParams,
    FindDuplicateBodyParams,
    FindDuplicatesResponse,
    ImportByUrlQueryParams,
    ImportResponse,
    MainEndpoints,
    MediaSigningResponse,
    MediaUploadResponse
} from "@authory-packages/core";
import axios from "axios";
import { API_URL } from ".";
import { getHeaders } from "./get-headers";

interface FindContentArgs {
    token: string;
    params: ImportByUrlQueryParams;
    timeout?: number;
}

export const findContent = async ({ token, params, timeout }: FindContentArgs) => {
    // Force custom extraction for all find content calls
    // params.forceCustomExtraction = true;

    const { data } = await axios.get<ImportResponse>(`${API_URL}${MainEndpoints.FindContent}`, {
        params,
        timeout,
        ...getHeaders(token)
    });
    return data;
};

interface CreateContentArgs {
    token: string;
    params: CreateContentBodyParams;
}

export const createContent = async ({ token, params }: CreateContentArgs) => {
    const { data } = await axios.post<ContentResponse>(
        `${API_URL}${MainEndpoints.CreateContent}`,
        {
            url: params.url,
            canonicalUrl: params.canonicalUrl,
            content: params.content,
            type: params.type,
            title: params.title,
            source: params.source,
            date: params.date,
            description: params.description,
            contentFromUser: params.contentFromUser,
            contentAboutUser: params.contentAboutUser,
            visibility: params.visibility,
            customThumbnailImage: params.customThumbnailImage,
            ogTitle: params.ogTitle,
            ogDescription: params.ogDescription
        },
        getHeaders(token)
    );

    return data;
};

interface FindDuplicatesArgs {
    token: string;
    params: FindDuplicateBodyParams;
    timeout?: number;
}

export const findDuplicates = async ({ token, params, timeout }: FindDuplicatesArgs) => {
    const { data } = await axios.post<FindDuplicatesResponse>(`${API_URL}${MainEndpoints.FindContentDuplicates}`, params, {
        timeout,
        ...getHeaders(token)
    });

    return data;
};

type UploadPDFArgs = {
    token: string;
    file: File;
};

export const findContentFromFile = async ({ token, file }: UploadPDFArgs) => {
    let formData = new FormData();
    formData.append("file", file);

    const res = await axios.post<ImportResponse>(`${API_URL}${MainEndpoints.FindContentFromFile}`, formData, {
        headers: {
            ...getHeaders(token).headers,
            "Content-Type": "multipart/form-data"
        }
    });

    return res.data;
};

interface importWebsiteScreenshotArgs {
    token: string;
    params: CreateWebsiteScreenshotQueryParams;
}

export const importWebsiteScreenshot = async ({ token, params }: importWebsiteScreenshotArgs) => {
    const { data } = await axios.get<ImportResponse>(`${API_URL}${MainEndpoints.TakeWebsiteScreenshot}`, {
        params,
        ...getHeaders(token)
    });
    return data;
};

interface createMediaUploadArgs {
    token: string;
    params: CreateMediaUploadBodyParams;
}

export const createMediaUpload = async ({ token, params }: createMediaUploadArgs) => {
    const { data } = await axios.post<MediaUploadResponse>(`${API_URL}${MainEndpoints.CreateMediaUpload}`, params, {
        ...getHeaders(token)
    });

    return data;
};

export const getSignedPlaybackToken = async ({ uploadId }: { uploadId: string }) => {
    const { data } = await axios.post<MediaSigningResponse>(`${API_URL}${MainEndpoints.SignMedia.replace(":uploadId", uploadId)}`, {}, {});

    return data.token;
};
